module.exports = __webpack_public_path__ + "static/media/matilde-hat-brazil-hello.56f1eacc.png";